<div class="members-manager">
  @if (isLoading()) {
  <div class="text-center py-4">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Caricamento...</span>
    </div>
  </div>
  } @else {
  <div class="mb-3 p-3 border rounded add-member-box" [class.opacity-75]="!canInvite()">
    <h6 class="fw-bold mb-2"><i class="bi bi-person-plus me-1"></i>Aggiungi membro</h6>
    <div class="mb-2">
      <label for="memberEmailInput" class="form-label small fw-semibold">Email dell'utente da aggiungere</label>
      <input
        type="email"
        id="memberEmailInput"
        class="form-control form-control-sm"
        [formControl]="emailControl"
        placeholder="Inserisci l'indirizzo email esatto..."
        [attr.disabled]="!canInvite() ? true : null"
        [class.is-invalid]="emailControl.invalid && (emailControl.dirty || emailControl.touched)"
      />
      @if (emailControl.invalid && (emailControl.dirty || emailControl.touched)) {
      <div class="invalid-feedback">
        @if (emailControl.errors?.['required']) {
        <span>L'indirizzo email è obbligatorio.</span>
        } @else if (emailControl.errors?.['email']) {
        <span>Inserisci un indirizzo email valido.</span>
        }
      </div>
      }
    </div>
    <div class="d-flex flex-wrap gap-2 mt-2 align-items-center">
      <select class="form-select form-select-sm w-auto" [(ngModel)]="newRole" [disabled]="!canInvite()"
        [title]="canInvite() ? '' : noPermissionTitle">
        @for (role of roles; track role) {
        <option [value]="role" [disabled]="!canAssignNewRole(role)">{{ role }}</option>
        }
      </select>
      <button class="btn btn-primary btn-sm"
        [disabled]="!canInvite() || !canAssignNewRole(newRole) || emailControl.invalid || isAdding()"
        [title]="canInvite() ? '' : noPermissionTitle" (click)="addMember()">
        @if (isAdding()) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        <i class="bi bi-plus-lg me-1"></i>Aggiungi
      </button>
    </div>
  </div>

  @if (members().length > 0) {
  <div class="d-flex flex-column gap-2">
    @for (member of members(); track member.userId) {
    <div class="member-row p-2 border rounded">
      <div class="d-flex align-items-center gap-2">
        <div
          class="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold member-avatar">
          {{ member.userName?.charAt(0) || '?' }}
        </div>
        <div class="flex-grow-1 min-w-0">
          <div class="fw-bold small text-truncate">{{ member.userName || 'Utente #' + member.userId }}</div>
          <div class="text-muted text-truncate" style="font-size: 11px;">{{ member.userEmail || '' }}</div>
        </div>
        <span class="badge" [ngClass]="getRoleBadgeClass(member.organizationRole)">
          {{ member.organizationRole || 'MEMBER' }}
        </span>
      </div>
      <div class="d-flex flex-wrap gap-2 mt-2">
        <select class="form-select form-select-sm w-auto" [value]="member.organizationRole"
          [disabled]="!canUpdateRole(member)" [title]="canUpdateRole(member) ? 'Cambia ruolo' : noPermissionTitle"
          (change)="updateRole(member, $any($event.target).value)">
          @for (role of roles; track role) {
          <option [value]="role" [selected]="member.organizationRole === role" [disabled]="!canAssign(role)">
            {{ role }}
          </option>
          }
        </select>

        <button class="btn btn-outline-danger btn-sm" [disabled]="!canRemove(member)"
          [title]="canRemove(member) ? 'Rimuovi membro' : noPermissionTitle" (click)="removeMember(member)">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="text-center text-muted py-4">
    <i class="bi bi-people fs-1"></i>
    <p class="mt-2 mb-0">Nessun membro trovato</p>
  </div>
  }
  }
</div>
